import { definirAppDeclaree } from '@taki/app-runtime';
import appInfo from './taki.app.json';
import champs from './taki.fields.json';
import ecrans from './taki.screens.json';
import { importDemoDataset } from './demo-dataset.js';

/**
 * L'APP PROJETS (`projets`), EN REGIME DECLARE : aucune ligne d'ecran.
 *
 * TROIS FICHIERS, ET C'EST TOUTE L'APP :
 *  - `taki.app.json` : la fiche d'identite (id, nom, icone, entites touchees) ;
 *  - `taki.fields.json` : ce que les champs SONT, jeu par jeu ;
 *  - `taki.screens.json` : OU ils s'affichent (les portes, les vues montees,
 *    le detail par vue, les cartes de la fiche, le tri, les gestes, et par
 *    porte son jeu, ses filtres, ses favoris, ses actions et ses stats).
 *
 * L'ECRAN VIENT DU SOCLE (`EcranDeclare`, `@taki/app-runtime`) : le
 * chargement, les gestes de fiche, l'acces au jeu, les compteurs du menu, les
 * preferences du poste et le panneau de reglages sont ecrits une fois, pour
 * toutes les apps declarees.
 *
 * CE QUI S'AJOUTE ICI QUAND LA DECLARATION LE NOMME, et jamais avant :
 * `fonctions` (un `fonctions.ts` qui porte ce que le fichier NOMME sans le
 * decrire), `effets` (l'effet d'une action qui n'est pas un ajout),
 * `canvas` (une surface de Space Canvas, regle G23) et `demo` (l'import du
 * jeu de demonstration, que le socle offre dans Parametres).
 */
export const projetsApp = definirAppDeclaree({
  fiche: appInfo,
  champs,
  ecrans,
  demo: { importer: ({ sdk, orgId }) => importDemoDataset(sdk, orgId) },
});

export default projetsApp;
